import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { icons, routes } from '../../../constants'
import { actions } from '../configuracaoPixAutomatico.actions'
import { ConfiguracaoPixAutomaticoForm } from './ConfiguracaoPixAutomaticoForm'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import _ from 'lodash'
import { logarAcesso } from '../../../services/api-log-acesso'
import { Toast } from 'primereact/toast'

const mapStateToProps = (state) => {
  const messages = state.crudConfiguracaoPixAutomaticoState.messages
  const record = state.crudConfiguracaoPixAutomaticoState.currentRecord
  let disableUnit = false
  let currentUnit = storage.getUnit()
  if (currentUnit) {
    let unidade = {
      id: currentUnit.oid,
      value: currentUnit.sigla,
    }
    Object.assign(record, { unidade: unidade })
    disableUnit = true
  }

  let unidades = utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany())

  return {
    record,
    messages,
    disableUnit,
    unidades,
    loadingValidarCredenciais: state.crudConfiguracaoPixAutomaticoState.loadingValidarCredenciais,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    reset: () => dispatch(actions.reset()),
    validarCredenciais: (dados) => dispatch(actions.validarCredenciais(dados)),
    clearValidacaoCredenciaisResponse: () => dispatch(actions.setValidacaoCredenciaisResponse(null)),

    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => {
      dispatch(actions.loadById(oid))
    },

    onChangeField: (field, value) => {
      dispatch(actions.removeErrors([{ field }]))

      if (['unidade'].includes(field) && typeof value === 'object') {
        value = { id: value.oid, value: value.sigla }
      }

      dispatch(actions.setField(field, value))
    },
  }
}

class ConfiguracaoPixAutomaticoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.toast = React.createRef()
    this.state = {
      showDialogRemove: false,
    }

    actions.beforeFetchRecordSuccess = (data) => {
      return data
    }

    actions.afterSave = (dados) => {
      this.props.history.replace(`${routes.PATH_CONFIGURACAO_PIX_AUTOMATICO}/${dados.oid}`)
    }

    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_CONFIGURACAO_PIX_AUTOMATICO}/novo`)
      this.props.reset()
    }

    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_CONFIGURACAO_PIX_AUTOMATICO}`)
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    } else {
      this.props.newHandler()
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_CONFIGURACAO_PIX_AUTOMATICO}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  clonarDados = () => {
    const clonedRecord = _.cloneDeep(this.props.record)

    this.props.newHandler()

    this.props.setField('oid', null)

    Object.keys(clonedRecord || {}).forEach((field) => {
      if (field === 'oid') return
      this.props.setField(field, clonedRecord[field])
    })
  }

  getBotoesPersonalizados = () => {
    let botoes = []
    if (this.props.record.oid && utils.nonNull(this.props.record.oid)) {
      let botao = {
        type: 'button',
        label: 'Clonar',
        className: 'p-button-success',
        onClick: (e) => this.clonarDados(),
        icon: icons.COPY_ICON,
      }
      botoes.push(botao)
    }
    return botoes
  }

  setCertificadoDigital = (data) => {
    const oid = _.get(data, 'oid', null)
    const nome = _.get(data, 'titularCommonName', '')

    const certificadoDigital = {
      id: oid,
      value: nome,
    }

    this.props.setField('certificadoDigital', certificadoDigital)
  }

  onValidarCredenciais = () => {
    const { record } = this.props
    const dados = {
      codigoPsp: record.codigoPsp,
      ambiente: record.ambiente,
      clientId: record.clientId,
      clientSecret: record.clientSecret,
      appKey: record.appKey,
      certificadoDigital: record.certificadoDigital,
    }
    this.props
      .validarCredenciais(dados)
      .then(() => {
        this.toast.current.show({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Credenciais validadas com sucesso!',
          life: 5000,
        })
      })
      .catch((error) => {
        const errorData = error.response?.data || {}
        let detailMessage = errorData.mensagem || errorData.error || 'Erro ao validar credenciais'

        if (errorData.responseBody) {
          try {
            const responseBody =
              typeof errorData.responseBody === 'string' ? JSON.parse(errorData.responseBody) : errorData.responseBody

            if (responseBody.error_description) {
              detailMessage += `\n\nDetalhes: ${responseBody.error_description}`
            } else if (responseBody.error) {
              detailMessage += `\n\nDetalhes: ${responseBody.error}`
            } else {
              detailMessage += `\n\nDetalhes: ${JSON.stringify(responseBody, null, 2)}`
            }
          } catch (e) {
            detailMessage += `\n\nDetalhes: ${errorData.responseBody}`
          }
        }

        if (errorData.statusCode) {
          detailMessage += `\n\nStatus Code: ${errorData.statusCode}`
        }

        this.toast.current.show({
          severity: 'error',
          summary: `Erro - ${errorData.psp || 'Validação'}`,
          detail: detailMessage,
          life: 8000,
        })
      })
  }

  render() {
    const content = (
      <>
        <Toast ref={this.toast} />
        <ConfiguracaoPixAutomaticoForm
          disableUnit={this.props.disableUnit}
          unidades={this.props.unidades}
          messages={this.props.messages}
          onChangeField={this.props.onChangeField}
          record={this.props.record}
          setCertificadoDigital={this.setCertificadoDigital}
          history={this.props.history}
          loadingValidarCredenciais={this.props.loadingValidarCredenciais}
          onValidarCredenciais={this.onValidarCredenciais}
        />
      </>
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfiguracaoPixAutomaticoFormPageContainer)
